const isString = (x) => typeof x === "string";
export {
  isString
};
